import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style15({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="codeName"
      onClick={onClick}
    />
  );
}
